import { IResponse } from "models";

export enum ActionType {
  RESEND_MESSAGE = "action/RESEND_MESSAGE",
  RESEND_MESSAGE_SUCCESS = "action/RESEND_MESSAGE_SUCCESS",
  RESEND_MESSAGE_ERROR = "action/RESEND_MESSAGE_ERROR",
  RESEND_MESSAGE_RESET = "action/RESEND_MESSAGE_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IResendMessagePayload {
  id: number;
}

export interface IResendMessageResponse extends IResponse {
  result: any;
}
